"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fmko_ts_common_1 = require("fmko-ts-common");
class HasValueWidget extends fmko_ts_common_1.Widget {
    constructor() {
        super(...arguments);
        this.handlerManager = new fmko_ts_common_1.HandlerManager();
    }
    /**
     * Sets the value to undefined. TODO: Change to null when we generally handle those.
     * @param fireEvents Boolean that determines whether an event should also be fired or not. Defaults to false.
     */
    clearValue(fireEvents = false) {
        this.setValue(undefined, fireEvents);
    }
    addValueChangeHandler(handler) {
        return this.handlerManager.addHandler(handler);
    }
    fireEvent(event) {
        this.handlerManager.fireEvent(event);
    }
}
exports.default = HasValueWidget;
//# sourceMappingURL=HasValueWidget.js.map